<template lang='pug'>
    v-card.elevation-1
        crud-form( submit-text='crear oferta' ref='form' v-bind='formProps' @calculate='calculate' @submitForm='submit' @reset='reset' )
            crud-data-table.detail-table( no-actions no-export no-search-box no-visual-help v-bind='tableProps' slot='appendContent' )
            v-btn.subheading.mt-3.ml-3( block color='success' outline slot='appendButton' @click='dialog = true' ) agregar productos
        v-dialog( content-class='white' fullscreen transition='dialog-bottom-transition' v-model='dialog' )
            v-toolbar( color='primary' dark flat )
                v-btn( icon @click='dialog = false' )
                    v-icon close
                v-toolbar-title Seleccionar productos
                v-spacer
                v-btn( color='accent' depressed @click='submitDialog' ) confirmar
                    v-icon.ml-2 done_all
            crud-data-table( checkable class='px-5 pt-2' no-actions no-auto-width no-export no-visual-help ref='dialogTable' v-bind='dialogTableProps' )
</template>

<script>
    //
    import { mapActions } from 'vuex'
    //import { CrudFieldset, CrudFormLayout, CrudFormSectionLayout, ModelDataTable } from '@/components/reusable_components/next'
    import { CrudForm, CrudDataTable } from '@/components/reusable_components'
    //
    import OfferService from '@/services/api/offer'
    import BranchOfficeService from '@/services/api/branchOffice'
    import FamilyService from '@/services/api/family/FamilyServices'
    import ProductService from '@/services/api/product'
    import ProviderService from '@/services/api/provider'
    import SubfamilyService from '@/services/api/subfamily/SubfamilyService'
    import TagService from '@/services/api/tag/TagServices'
    import WarehouseService from '@/services/api/warehouse'
    import saleUtils from '@/services/SaleUtils'
    //
    import GeneralFields from './partials/fields/general'
    import ProductFilters from './partials/filters/product'
    import ProductHeaders from './partials/headers/product'
    import DetailsHeaders from './partials/headers/detail'
    //
    export default {
        components: {
            'crud-form': CrudForm,
            'crud-data-table': CrudDataTable,
        },
        computed: {

            /**
             * 
             */
            dialogTableProps () {
                return {
                    filters: this.dialogFilters,
                    headers: ProductHeaders,
                    service: ProductService,
                }
            },

            /**
             * 
             */
            formProps () {
                return {
                    fields: this.formFields,
                }
            },

            /**
             * 
             */
            tableProps () {
                return {
                    filters: [],
                    headers: DetailsHeaders,
                    service: this.service,
                }
            },
        },
        data () {
            return {
                dialog          : false,
                dialogFilters   : ProductFilters,
                formFields      : JSON.parse( JSON.stringify( GeneralFields ) ),
                products        : [],
                service         : {
                    dtFetchData: () => ({
                        data: []
                    })
                },
            }
        },
        methods: {

            /**
             * 
             */
            ...mapActions('MenuesModule', {
                setTitleTopBar: 'setTitleTopBar',
            }),

            /**
             * 
             */
            ...mapActions('SnackbarModalModule', {
                initSnackbar: 'initSnackbar',
                resetSnackbarState: 'resetSnackbarState',
                setMessageConfirmSnack: 'setMessageConfirmSnack',
            }),

            /**
             * 
             */
            calculate ( event ) {
                switch ( event.field ) {
                    case 'branchOfficeId': 
                    case 'discount':
                        this.products = [ ...this.products.map( this.mapSelectedToProduct ) ]
                        this.service = {
                            dtFetchData: () => ({
                                data: this.products
                            })
                        }
                        break;
                }
            },

            /**
             * 
             */
            findById ( id ) {
                return function ( item ) {
                    return item.id === id
                }
            },

            /**
             * 
             */
            mapProduct ( product ) {
                return {
                    id          : product.id,
                    offer_price : product.virtual_offer_price,
                }
            },

            /**
             * 
             */
            mapSelectedToProduct ( product ) {

                const salePrice     = ( product.sale_prices.find( this.findById ) || {} ).sale_price || 0
                    , offerDiscount = Number( this.$refs.form.vmodels.discount )
                    , offerPrice    = saleUtils.priceWithDiscount( salePrice, offerDiscount )

                return {
                    ...product,
                    sale_price_by_branch_office: salePrice,
                    virtual_offer_price: offerPrice,
                }
            },

            /**
             * 
             */
            async reset () {
                //
                this.formFields = JSON.parse( JSON.stringify( GeneralFields ) )
                //
                this.formFields[ 0 ].options.data   = await BranchOfficeService.fetchAll()
                //
                this.dialogFilters[ 0 ].options     = await ProviderService.fetchAll()
                this.dialogFilters[ 1 ].options     = await WarehouseService.fetchAll()
                this.dialogFilters[ 3 ].options     = await FamilyService.fetchAllFamily()
                this.dialogFilters[ 4 ].options     = await SubfamilyService.fetchAll()
                this.dialogFilters[ 5 ].options     = await TagService.fetchAll()
                //
                this.$refs.dialogTable.checkAll()
                this.$refs.dialogTable.checkAll()
                this.submitDialog()
            },

            /**
             * 
             */
            response ( response ) {
                switch ( response.status ) {
                    case 'error':
                        this.showSnackbar( 'error', 'Error', response.errors || response.error || response.message );
                        break;
                    case 'success': 
                        this.showSnackbar( 'success', 'Éxito', 'Oferta creada con éxito.' );
                        this.$router.push( '/offer' )
                        break;
                }
            },

            /**
             * 
             */
            showSnackbar ( color, title, message ) {
                this.resetSnackbarState()
                this.initSnackbar( this.fillSnack( color, title, message, false, 3000 ) );
            },

            /**
             * 
             */
            async submit ( event ) {
                this.response(
                    await OfferService.createMassive({ 
                        ...event,
                        products: this.products.map( this.mapProduct ), 
                    })
                )
            },

            /**
             * 
             */
            submitDialog ( event ) {
                this.dialog   = false
                this.products = this.$refs.dialogTable.selected.map( this.mapSelectedToProduct )
                this.service = {
                    dtFetchData: () => ({
                        data: this.products
                    })
                }
            }
        },
        async mounted () {
            this.reset()
            this.setTitleTopBar( 'Crear oferta' )
        },
    }
</script>

<style>
    .detail-table .table-container {
        width: 100% !important;
    }
</style>

